//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
import ContactUtils from '../../../utils/contact';
import DataItem from '../../../data/Item';
var isLead = ContactUtils.isLead,
    getDisplayName = ContactUtils.getDisplayName,
    getPropVal = ContactUtils.getPropVal;
/**
 * @typedef { object } ContactModel Data model returned by the sever representing a Contact.
 * @property { number } Id Contact unique identifier.
 * @property { number[] } ParentAccountIds
 * @property { string } LastModifiedUTC
 * @property { object[] } Properties Contact properties.
 *
 * */

/**@type {import('../types').DataType<ContactModel>} */

var CONTACT_DATA_TYPE = {
  data: {
    url: '/backend/contacts',
    itemUrl: '/backend/contacts?id={id}',
    deleteItemUrl: '/backend/contacts?contactId={id}',
    dataKey: 'contacts',
    idKeyProp: 'Id',
    filterUrlKey: 'Query',
    onBeforeRequest: function onBeforeRequest(props, request) {
      if (request.type === 'loadView' && props.dataProps && props.dataProps.viewType) {
        return {
          query: {
            viewType: props.dataProps.viewType
          }
        };
      }
    }
  },
  placeholders: {
    type: function type(data) {
      return isLead(data) ? 'lead' : 'contact';
    },
    label: function label(data) {
      var name = getDisplayName(data);
      return name ? name : '(No name)';
    },
    icon: function icon(data) {
      return isLead(data) ? 'lead' : 'contact';
    }
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.DataLink, {
        dataType: "contact",
        data: data,
        component: "span"
      });
    },
    serverSort: true //inmemorysort: data => getDisplayName(data),

  }, {
    id: 'Account',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      if (!(data.ParentAccountIds && data.ParentAccountIds.length)) return React.createElement(Formatter.MissingValue, null);
      return React.createElement(React.Fragment, null, data.ParentAccountIds.map(function (accountId) {
        return React.createElement(DataItem, {
          dataType: "account",
          id: accountId,
          key: accountId
        }, function (_ref3) {
          var value = _ref3.value;
          return React.createElement(Formatter.DataLink, {
            dataType: "account",
            data: value,
            component: "span"
          });
        });
      }));
    } //inmemorysort: data => data.ParentAccountIds && data.ParentAccountIds[0],

  }, {
    id: 'Email',
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return React.createElement(Formatter.Email, {
        value: getPropVal(data, 'Email')
      });
    },
    serverSort: true,
    //inmemorysort: data => getPropVal(data, 'Email'),
    width: {
      xs: 0,
      sm: 'auto'
    }
  }, {
    id: 'Title',
    formatter: function formatter(_ref5) {
      var data = _ref5.data;
      return React.createElement(Formatter.Text, {
        value: getPropVal(data, 'Title')
      });
    },
    //inMemorySort: data => getPropVal(data, 'Title'),
    width: {
      xs: 0,
      sm: 0,
      md: 0,
      lg: 'auto'
    }
  }, {
    id: 'Phone',
    formatter: function formatter(_ref6) {
      var data = _ref6.data;
      return React.createElement(Formatter.Text, {
        value: getPropVal(data, 'Phone')
      });
    },
    //inmemorysort: data => getPropVal(data, 'Phone'),
    width: {
      xs: 0,
      sm: 0,
      md: 'auto'
    }
  }, {
    id: 'OwnerName',
    children: 'Contact Owner',
    formatter: function formatter(_ref7) {
      var data = _ref7.data;
      return React.createElement(Formatter.Link, {
        text: getPropVal(data, 'OwnerName'),
        value: getPropVal(data, 'OwnerEmail'),
        component: "a"
      });
    },
    //inmemorysort: data => getPropVal(data, 'OwnerName'),
    width: {
      xs: 0,
      sm: 0,
      md: 0,
      lg: 'auto'
    }
  }, {
    id: 'CreatedUTC',
    children: 'Date Created',
    formatter: function formatter(_ref8) {
      var data = _ref8.data;
      return React.createElement(Formatter.DateTime, {
        value: getPropVal(data, '_system_CRM_CreatedDate') || getPropVal(data, '_system_CreatedDate')
      });
    },
    //serverSort: true,
    // inMemorySort: data =>
    //   getPropVal(data, '_system_CRM_CreatedDate') ||
    //   getPropVal(data, '_system_CreatedDate'),
    //
    width: {
      xs: 0,
      sm: 0,
      md: 0,
      lg: 'auto'
    }
  }, {
    id: 'LastModifiedUTC',
    children: 'Last Modified',
    formatter: function formatter(_ref9) {
      var data = _ref9.data;
      return React.createElement(Formatter.DateTime, {
        value: data.LastModifiedUTC
      });
    },
    serverSort: true,
    //inmemorysort: data => data.LastModifiedUTC,
    width: {
      xs: 0,
      sm: 0,
      md: 'auto'
    }
  }, {
    id: 'CRM_Type',
    children: 'Type',
    formatter: function formatter(_ref10) {
      var data = _ref10.data;
      return React.createElement(Formatter.Text, {
        value: isLead(data) ? 'Lead' : 'Contact'
      });
    },
    serverSort: false,
    width: {
      xs: 0,
      sm: 120
    }
  }, {
    id: true,
    formatter: function formatter(_ref11) {
      var data = _ref11.data,
          column = _ref11.column;

      if (column.type) {
        if (column.type === 'datetime') return React.createElement(Formatter.DateTime, {
          value: getPropVal(data, column.id)
        });
        if (column.type === 'email') return React.createElement(Formatter.Email, {
          value: getPropVal(data, column.id)
        });
        if (column.type === 'bool') return React.createElement(Formatter.Switch, {
          value: getPropVal(data, column.id)
        });
      }

      return React.createElement(Formatter.Text, {
        value: getPropVal(data, column.id)
      });
    }
  }],
  thumbnail: {
    text: function text(data) {
      return getDisplayName(data);
    },
    icon: function icon(data) {
      return isLead(data) ? 'lead' : 'contact';
    }
  },
  contextMenu: [{
    type: 'open'
  }, 'separator', {
    type: 'delete'
  }]
};
export default CONTACT_DATA_TYPE;